//$(document).ready(() => {
//    ($('.product-owl-carousel') as any).owlCarousel({
//        rtl: true,
//        dots: false,
//        nav: true,
//        responsive: {
//            0: {
//                items: 2
//            },
//            400: {
//                items: 2
//            },
//            600: {
//                items: 4
//            },
//            1000: {
//                items: 5
//            }
//        }
//    });
//});

$(document).ready(() => {
    ($('.ProductCarousel') as any).slick({
        slidesToShow: 5,
        centerMode: false,
        centerPadding: 0,
        infinite: false,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    infinite: false,
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 600,
                settings: {
                    infinite: false,
                    slidesToShow: 2
                }
            }
        ]
    });
})
